import { Rectangle } from "./Rectangle"
import { Point } from "./Point"
import { exists } from "./utils";


export function Distance(a: number|Point, b:number|Point) : number {
    if(a instanceof Point){
        if (b instanceof Point){
            return Rectangle.build(a, b).Hypotenuse;
        }
    }
    if (typeof(a)===typeof(1)){
        if (typeof(b)===typeof(1)){
            return Math.max(<number>a, <number>b) - Math.min(<number>a, <number>b);
        }        
    }
    console.error(`Cannot calculate Distance between ${typeof(a)} and ${typeof(b)}`)
    return 0;
   
}



/** returns a Point from two Rectangles, but it's actually returning a ratio from two coordinate spaces */
function Scale(from_rect: Rectangle, to_rect: Rectangle): Point
{
    let x : number = to_rect.Width / from_rect.Width
    let y : number = to_rect.Height / from_rect.Height
    return Point.build(x, y)
}

export function js_translate(old_x:number, old_y:number, 
                             old_p1_x:number, old_p1_y:number, 
                             old_p2_x:number, old_p2_y:number, 
                             new_p1_x:number, new_p1_y:number, 
                             new_p2_x:number, new_p2_y:number) {

    let old_coord:Point = Point.build(old_x, old_y)
    let old_system_rectangle:Rectangle = Rectangle.build(Point.build(old_p1_x, old_p1_y), Point.build(old_p2_x, old_p2_y));
    let new_system_rectangle:Rectangle = Rectangle.build(Point.build(new_p1_x, new_p1_y), Point.build(new_p2_x, new_p2_y));
    let new_coord = Translate(old_coord, old_system_rectangle, new_system_rectangle)
    return [new_coord.X, new_coord.Y]
}

export function Translate(old_point :Point, old_system_rectangle:Rectangle, new_system_rectangle:Rectangle):Point
{
    let oldSys:Rectangle=old_system_rectangle;
    let newSys:Rectangle=new_system_rectangle;
    if (!exists(newSys)){
        return old_point;
    }
    if (!exists(oldSys)){
        return null;
    }
    if (oldSys.Left==newSys.Left)
    {
        if (oldSys.Right==newSys.Right)
        {
            if (oldSys.Top==newSys.Top)
            {
                if (oldSys.Bottom==newSys.Bottom)
                {
                    return Point.build(old_point.X, old_point.Y); // if old p1p2 == new p1p2, no change to the point
                }
            }
        }
    }

    let scale: Point = Scale(oldSys, newSys)
    let new_x: number = newSys.Left + (scale.X * (old_point.X - oldSys.Left))
    let new_y: number = newSys.Bottom + (scale.Y * (old_point.Y - oldSys.Bottom))
    return Point.build(new_x, new_y)
}


/* If p1 is within minimum_distance of p2, nudge p1 a little (less than nudge_max) */

export function Nudge(p1:Point,p2:Point, minimum_distance:number, nudge_max:number):Point
{
    let ret_val:Point = p1;
    let out:Point = p1
    let is_inside:boolean = Distance(p1, p2) < minimum_distance
    if (is_inside)
    {
        let random_distance = function(nudge_max:number)
        {
            let negate = (0 === Math.floor(Math.random()*10%2));
            let nudge_distance = (Math.floor(Math.random() * nudge_max) + 1);
           if(negate){
               nudge_distance = nudge_distance * -1
           }
           return nudge_distance;
        }
        ret_val.X += random_distance(nudge_max)
        ret_val.Y += random_distance(nudge_max)
    }
    return ret_val
}



// WEBPACK FOOTER //
// ./src/ts/Geometry.ts